import type { ScreenviewNode } from '../../types';
import { ConditionCard } from '../condition-card';
import { Bold, Times, Within } from '../condition-parts';

type ScreenviewConditionProps = { node: ScreenviewNode };

export function ScreenviewCondition({ node }: ScreenviewConditionProps) {
  const prefix = node.inverse ? 'Has not' : 'Has';
  return (
    <ConditionCard node={node}>
      {prefix} viewed a screen
      {node.screen != null ? (
        <>
          {' '}
          matching <Bold>{node.screen}</Bold>
        </>
      ) : null}
      <Times times={node.times} />
      <Within within={node.within} />
    </ConditionCard>
  );
}
